/**
 * Extracts query parameters from a URL.
 *
 * This function locates the first occurrence of the '?' character in the provided URL string
 * and returns the substring that follows it. If the '?' is not found, indicating there are
 * no query parameters, the function returns an empty string.
 *
 * @param {string} url - The URL from which to extract the query parameters.
 * @returns {string} The substring containing the query parameters, or an empty string if none are present.
 */
export function splitParams(url: string): string {
	const questionMarkIndex = url.indexOf('?');
	if (questionMarkIndex === -1) {
		return '';
	}
	return url.substring(questionMarkIndex + 1);
}
